import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { postLinkedInIntegration } from 'services/integrationService';
import { useSelector } from 'react-redux';

const LinkedInCallback = () => {
  const location = useLocation();
  const { user } = useSelector((state) => state.auth);
  const { current_subscription: currentSubscription } =
    user?.subscriptions ?? {};
  const requestInFlight = useRef(false);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const code = queryParams.get('code');
    const type = queryParams.get('type');
    const redirectURI = process.env.REACT_APP_LINKEDIN_OAUTH_REDIRECT_URI;

    if (code && !requestInFlight.current) {
      requestInFlight.current = true;

      postLinkedInIntegration({ code, redirect_uri: redirectURI, type })
        .then((data) => {
          if (type === 'org') {
            window.opener.postMessage(
              { type: 'LINKEDIN_SUCCESS', payload: data.data },
              '*',
            );
          } else {
            window.opener.postMessage(
              { type: 'LINKEDIN_SUCCESS', payload: { type: 'profile' } },
              '*',
            );
          }
          window.close();
        })
        .catch((error) => {
          console.error('Error fetching LinkedIn token:', error);
          if (window.opener) {
            window.opener.postMessage(
              { type: 'LINKEDIN_ERROR', payload: error.response.data },
              '*',
            );
          }
          // Close the popup
          window.close();
        })
        .finally(() => {
          requestInFlight.current = false;
        });
    }
  }, [location, currentSubscription]);

  return <div>Processing LinkedIn Login...</div>;
};

export default LinkedInCallback;
